module.exports = __webpack_public_path__ + "static/media/musee-d-orsay.c376aa41.jpg";